import { Position, Toaster } from "@blueprintjs/core";

export default Toaster.create({
    className: "top-toaster",
    position: Position.TOP_CENTER,
});



/** WEBPACK FOOTER **
 ** ./src/toaster.js
 **/